import { useMutation, useQuery } from 'react-query'
// Antd
import { Form, message } from 'antd'
import { useRouter } from '@uirouter/react'
import authService from 'authService'
import axiosRequest from 'utils/axiosRequest'
// helpers
import get from 'lodash/get'

const {
  REACT_APP_CLIENT_ID: user,
  REACT_APP_API_KEY: password,
  REACT_APP_AUTH_URL: authUrl
} = process.env

const getUser = async () => {
  const { data } = await axiosRequest({
    url: '/user/info',
    method: 'GET',
    baseURL: authUrl,
    headers: {
      Authorization: `Bearer ${authService.state.authToken}`
    }
  })

  return data
}

const getCatalog = async () => {
  const { data } = await axiosRequest({
    url: '/event/catalogs',
    method: 'GET',
    baseURL: authUrl,
    headers: {
      Authorization: `Bearer ${authService.state.authToken}`
    }
  })

  return data
}

const useGetUser = () => {
  const { stateService } = useRouter()

  const onError = () => {
    authService.logout(false)
    stateService.go('App.login')
  }

  const {
    data: authData,
    isLoading,
    isError
  } = useQuery({
    queryKey: 'puntos_ideas_get_user',
    queryFn: () => { getCatalog(); return getUser() },
    onSuccess: data => {
      const username = get(data, 'username', null)
      const firstname = get(data, 'firstname', null)
      const lastname = get(data, 'lastname', null)
      const roles = get(data, 'roles', [])
      const externalAccess = get(data, 'externalAccess', {
        accessToken: '',
        clientId: ''
      })

      if (username) {
        authService.setLogin(
          externalAccess.accessToken,
          `${firstname} ${lastname}`,
          externalAccess.clientId,
          roles
        )
        stateService.reload()
      } else onError()
    },
    onError
  })

  return {
    isLoading,
    isError
  }
}

export default useGetUser
